import { CloseButton as DrywallCloseButton } from 'drywall';
import styled from 'styled-components';
import { CloseButtonMixin } from '../../mixins/components/CloseButtonMixin';

/**
 * An HTML `<button>` element used for closing content such as dialogs.
 *
 * @since 7.4.0
 */
export var StyledCloseButton = /*#__PURE__*/styled(DrywallCloseButton).withConfig({
  displayName: "StyledCloseButton",
  componentId: "c11n-8-111-1__sc-107ty8u-0"
})(["", ""], CloseButtonMixin);